import { AppName } from "./utils/constants";
import tenantConfigJson from "./tenant-config.json";

export interface TenantLogo {
  src: string;
  alt: string;
}

export interface TenantConfig {
  displayName: string;
  projectName: string;
  description: string;
  shortName: string;
  manifestName: string;
  themeColor: string;
  backgroundColor: string;
  favicon: string;
  appleTouchIcon: string;
  icon192: string;
  icon512: string;
  logoLogin: TenantLogo;
  logoDrawerSmall: TenantLogo;
  logoDrawerMain: TenantLogo;
  taskIconColor: string;
}

export const TENANT_CONFIG: Record<AppName, TenantConfig> = tenantConfigJson as Record<AppName, TenantConfig>;

/** Single source of truth for per-tenant branding, falling back to FaunaProtect for unknown/missing tenants. */
export const getTenantConfig = (appName: AppName): TenantConfig =>
  TENANT_CONFIG[appName] ?? TENANT_CONFIG[AppName.FaunaProtect];
